import { css } from '@emotion/react'

export const relative = css`
  position: relative;
`
